module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lng_en":{"selectedTypeOnly":"Selected %{optionType}s only"},"lng_id":{"selectedTypeOnly":"Selected %{optionType}s only"},"lng_th":{"selectedTypeOnly":"Selected %{optionType}s only"},"lng_zh":{"selectedTypeOnly":"Selected %{optionType}s only"},"lng_ko":{"selectedTypeOnly":"선택한 %{optionType}에 한함"}}')
  delete Component.options._Ctor
}
